import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFeaturedLab, setHasFeaturedLab } from '../../../actions/labs'

//Note: We will use this component to manage the state of the sidebar. 
const SidebarStateManager = () => {
  const dispatch = useDispatch()

  // Featured lab logic here
  /*****************************************/
  const { labs } = useSelector(state => state.api) || {}

  useEffect(() => {
    // Fetch labs on app mount
    dispatch(getFeaturedLab())
    
    
  }, [dispatch])

  useEffect(() => {
    if(labs.isFetched) {
      const hasFeaturedLab = Object.values(labs.entities).some(lab => lab.isFeatured)
      dispatch(setHasFeaturedLab(hasFeaturedLab))
    }

  }, [dispatch, labs])
  /*****************************************/

  return null
}

export default SidebarStateManager